(function () {
  /*
   * O bloco de upsell do carrinho agora é renderizado diretamente dentro de
   * <cart-drawer-items>, pelo Liquid (snippets/cart-drawer.liquid).
   *
   * Antes, ele era renderizado fora do <cart-drawer> e este script copiava o
   * HTML para dentro do drawer em tempo de execução. Isso criava IDs
   * duplicados (#cart-drawer-upsell aparecia duas vezes na página) e um
   * MutationObserver que refazia fetch da página inteira a cada alteração do
   * carrinho — o que embaralhava o layout do drawer.
   *
   * A atualização da lista agora acontece de graça: cart.js (onCartUpdate)
   * já substitui <cart-drawer-items> inteiro via section rendering.
   */

  window.onChangeKsUpsellVariantSelector = function (select, event) {
    if (event) event.preventDefault();

    var option = select.options[select.selectedIndex];
    if (!option) return;

    var imgSrc = option.dataset.variantImg;
    if (!imgSrc) return;

    var item = select.closest('.cart-drawer-upsell-list-item');
    if (!item) return;

    var img = item.querySelector('.cart-drawer-upsell-list-item-left img');
    if (img) img.src = imgSrc;
  };
})();
